import { render } from "./OrderPdfView.vue?vue&type=template&id=91f66b40"
import script from "./OrderPdfView.vue?vue&type=script&lang=js"
export * from "./OrderPdfView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__